import Tabs from './Tabs'

export default Tabs
// eslint-disable-next-line import/export
export * from './Tabs'
